import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";

const TimeList = ({ timeList, setChange, targetTime, targetKey }) => {
  const [selectedTime, setSelectedTime] = useState(null);
  const scrollRef = useRef(null);

  const findMiddleElement = () => {
    const container = scrollRef.current;
    const scrollTop = container.scrollTop;
    let middleElem = Math.round(scrollTop / 50);
    return timeList[middleElem];
  };

  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  const handleScroll = debounce(() => {
    const newSelectedTime = findMiddleElement();
    if (newSelectedTime !== selectedTime) {
      setSelectedTime(newSelectedTime);
      setChange(newSelectedTime);
    }
  }, 100);

  const handleSnapScroll = () => {
    const container = scrollRef.current;
    const scrollTop = container.scrollTop;
    const snapPoint = Math.round(scrollTop / 50) * 50;
    container.scrollTo({
      top: snapPoint,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const container = scrollRef.current;
    container.addEventListener("scroll", handleScroll);

    let scrollTimeout = null;
    const handleEndScroll = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(handleSnapScroll, 100);
    };
    container.addEventListener("scroll", handleEndScroll);
    document.querySelector(`.${targetKey}`)?.focus();
    setTimeout(() => {
      const middleIndex = targetTime ?? 0;
      const snapPoint = middleIndex * 50;
      container.scrollTo({
        top: snapPoint,
        behavior: targetTime ? "auto" : "smooth",
      });
      setSelectedTime(timeList[middleIndex]);
      setChange(timeList[middleIndex]);
    }, 0);

    return () => {
      container.removeEventListener("scroll", handleScroll);
      container.removeEventListener("scroll", handleEndScroll);
    };
  }, [selectedTime]);

  return (
    <ScrollContainer ref={scrollRef} className={targetKey} tabIndex={-1}>
      <TimeItem key={-1} selected={false}></TimeItem>
      {timeList.map((time, index) => (
        <TimeItem key={index} selected={time === selectedTime}>
          {time < 10 ? `0${time}` : time}
        </TimeItem>
      ))}
      <TimeItem key={timeList.length} selected={false}></TimeItem>
    </ScrollContainer>
  );
};

const ScrollContainer = styled.div`
  overflow-y: auto;
  height: 150px;
  padding: 10px;
  position: relative;
  scrollbar-width: none;
`;

const TimeItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  padding: 10px;
  text-align: center;
  color: ${(props) => (props.selected ? "var(--DarkNavy)" : "var(--Gray)")};
  font-size: var(--font-size-32);
  font-weight: ${(props) =>
    props.selected ? "var(--font-weight-bold)" : "var(--font-weight-normal)"};
`;

export { TimeList };
